import { CARD_TYPES, LeadCardType } from 'cards/constants/CardTypes';
import { LABEL_BY_CARD_TYPE } from 'cards/constants/labelByCardType';

export const getLabelByCardType = (cardType?: LeadCardType, isDigital?: boolean): string => {
  const updatedType = isDigital ? CARD_TYPES.dstd : cardType;
  return (updatedType && LABEL_BY_CARD_TYPE[updatedType]) || '';
};
